import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { usersStatisticsRequest } from "../../store/users/actions";
import { internalImg } from "../../utils/images";
import { factoryImg } from "../../utils/images";
import { hospitalImg } from "../../utils/images";
import "./style.scss";

const Users = ({ intl: { messages } }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { usersStatistics } = useSelector((state) => state.users);
    const user = useSelector((state) => state.auth?.user?.data);
    const lang = localStorage.getItem("lang") || "en";

    useEffect(() => {
        dispatch(usersStatisticsRequest());
    }, [dispatch]);

    const handleRedirect = (route) => {
        history.push(route);
    };

    if (user?.role_id !== 1) {
        return "Your are not authorized to view this page";
    }

    const handleRedirectAdd = (e, addType) => {
        e.stopPropagation();
        switch (addType) {
            case "internal":
                handleRedirect("/users/internal/add");
                break;
            case "labs":
                handleRedirect("/users/labs/add");
                break;
            case "hospitals":
                 handleRedirect("/users/hospitals/add");
                break;
            default:
                break;
        }
    }

    return (
        <section className="users-container">
            <div className="users-categories">
                <div className="users-category" onClick={() => handleRedirect('/users/internal')} >
                    <img src={internalImg} alt="Category" />
                    <h3>{usersStatistics.internal_users}</h3>
                    <h4>{messages.users.internal}</h4>
                    <button className={lang === 'ar' && "rtl"} onClick={e => handleRedirectAdd(e, 'internal')}><AddCircleOutlineOutlinedIcon />{messages.users.add_user}</button>
                </div>
                <div className="users-category" onClick={() => handleRedirect('/users/labs')}>
                    <img src={factoryImg} alt="Category" />
                    <h3>{usersStatistics.labs}</h3>
                    <h4>{messages.users.factory}</h4>
                    <button className={lang === 'ar' && "rtl"} onClick={e => handleRedirectAdd(e, 'labs')}><AddCircleOutlineOutlinedIcon />{messages.users.add_lab}</button>
                </div>
                <div className="users-category" onClick={() => handleRedirect('/users/hospitals')}>
                    <img src={hospitalImg} alt="Category" />
                    <h3>{usersStatistics.hospitals}</h3>
                    <h4>{messages.users.hospital}</h4>
                    <button className={lang === 'ar' && "rtl"} onClick={e => handleRedirectAdd(e, 'hospitals')}><AddCircleOutlineOutlinedIcon />{messages.users.add_hospital}</button>
                </div>
            </div>
        </section>
    )
}

export default injectIntl(Users);
